import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from 'shared/layouts/containers/Main'
import { Button, Form, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import InputWrapper from 'shared/components/InputWrapper'
import resAddFailureReason from './resolvers/resAddFailureReason'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import prepareSubmitForm from 'shared/utils/prepareSubmitForm'
import submitForm from './utils/submitForm'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import BackButton from 'shared/components/BackButton'

const AddFailureReason: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)

  const submitRef = React.createRef<HTMLButtonElement>()

  const { id } = useParams()

  const navigate = useNavigate()

  const {
    register,
    getValues,
    handleSubmit,
    reset,
    setFocus,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resAddFailureReason,
  })

  useInit({
    getValues,
    id,
    reset,
    setDataLoaded,
    setShowOverlay,
  })

  useFocusError({
    errors,
    setFocus,
  })

  return (
    <Layout 
      footerContent={<Footer />} 
      brandContent={getBrandContent()} 
      showOverlay={showOverlay}
      showCardHeader={true}
      showMinimizedBarButton={true}
      headerInsert={
        <BackButton url='/failure-reasons' text='All Failure Reasons' />
      }
      actionInsert={
        <Button
          disabled={!dataLoaded}
          type='submit'
          name='save'
          className='btn-round btn-primary'
          onClick={() => {
            if (submitRef.current != null) {
              submitRef.current.click()
            }
          }}
        >
          Save Failure Reason
        </Button>
      }
    >
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            navigate,
            data,
            setShowOverlay,
            id,
            name: 'Failure Reason',
            successNav: '/failure-reasons',
            setError,
          }),
        )}
        id='main-form'
      >
        <InputWrapper label='Name' name='name' errors={errors}>
          <Form.Control type='text' {...register('name')} />
        </InputWrapper>

        <InputWrapper label='Show' name='show' errors={errors}>
          <Form.Select {...register('show')}>
            <option key={0} value={1}>
              Yes
            </option>
            <option key={1} value={0}>
              No
            </option>
          </Form.Select>
        </InputWrapper>

        <Button
          type='submit'
          name='save'
          ref={submitRef}
          className='d-none'
        ></Button>
      </Form>
    </Layout>
  )
}

export default AddFailureReason
